<template>
  <div>
    <el-row class="tcf-row">
      <el-col>
        <div>
          <el-row>
            <el-col :span="6">
              <el-card class="card">
                <div style="margin-bottom: 20px">
                  产品出错部门排行
                </div>
                <el-date-picker
                  v-model="complaintRankTime"
                  style="width: 200px"
                  size="mini"
                  type="monthrange"
                  format="yyyy-M"
                  value-format="yyyy-M"
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份">
                </el-date-picker>
                <el-button icon="el-icon-search" size="mini" @click="getComplaintDeptRank">搜索</el-button>
                <div>
                  <div id="complaintRankChart" style="height: 400px"></div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="card" style="text-align: center;margin: 0 28px">
                <div style="margin-bottom: 20px">
                  客诉统计
                </div>
                <el-date-picker
                  v-model="time"
                  type="month"
                  size="mini"
                  format="yyyy-M"
                  value-format="yyyy-M"
                  placeholder="选择月">
                </el-date-picker>
                <el-button icon="el-icon-search" size="mini" @click="getComplaintType">搜索</el-button>
                <div>
                  <ul style="white-space:nowrap">
                    <li style="display:inline-block"><span>客诉总汇（年）<br>{{ vo.yearNum }}</span></li>
                    <li style="display:inline-block;margin-left: 30px"><span>客诉完成<br>{{ vo.comNum }}</span></li>
                    <li style="display:inline-block;margin-left: 30px"><span>完成率<br>{{ vo.comPercent }}%</span></li>
                    <li style="display:inline-block;margin-left: 30px"><span>客诉次数（月）<br>{{ vo.monthNum }}</span></li>
                    <li style="display:inline-block;margin-left: 30px"><span>未处理</span><br>{{ vo.unComNum }}</li>
                  </ul>
                </div>
                <div id="complaintTypeChart" style="height: 320px"></div>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="card">
                <div style="margin-bottom: 20px;float: right">
                  客诉未处理个数明细
                </div>
                <div id="complaintNumChart" style="height: 400px;margin-top: 72px"></div>
              </el-card>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-card class="card" style="margin-top: 28px;height: 524.2px">
                <div style="margin-bottom: 20px">
                  客诉整改完成率
                  <el-button icon="el-icon-edit" size="mini" style="float: right" @click="dialogVisible = true">编辑</el-button>
                </div>
                <el-row>
                  <el-col :span="12">
                    <div id="chart1" style="height:150px"/>
                  </el-col>
                  <el-col :span="12">
                    <div id="chart2" style="height:150px"/>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" style="height:150px">
                    <div id="chart3"/>
                  </el-col>
                  <el-col :span="12" style="height:150px">
                    <div id="chart4"/>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="card" style="text-align: center;margin: 28px 28px 0 28px;height: 524.2px;overflow-y: auto">
                <div style="margin-bottom: 20px">
                  近期客诉信息列表展示
                </div>
                <div class="card-content">
                  <el-table
                    :data="tableData"
                    stripe
                    size="mini"
                    style="width: 100%">
                    <el-table-column
                      prop="date"
                      label="日期"
                      show-overflow-tooltip
                      min-width="120">
                    </el-table-column>
                    <el-table-column
                      prop="ordernum"
                      fixed
                      label="订单号"
                      show-overflow-tooltip
                      min-width="120">
                    </el-table-column>
                    <el-table-column
                      label="生产单号"
                      align="center"
                      show-overflow-tooltip
                      min-width="120">
                      <template slot-scope="scope">
                        <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      align="left"
                      label="客户地址"
                      show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="专卖店"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column
                      prop="groupName"
                      label="车间"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                    </el-table-column>
                    <el-table-column
                      label="外派维修"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===1">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="加急补单"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===2">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="系统未处理"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===3">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="紧急售后"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===4">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="待办事项"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===5">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="未接电话"
                      align="center"
                      show-overflow-tooltip
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type===6">√</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="analyze"
                      label="问题分析"
                      align="left"
                      show-overflow-tooltip
                      width="200">
                    </el-table-column>
                    <el-table-column
                      prop="scheme"
                      align="left"
                      label="解决方案"
                      show-overflow-tooltip
                      width="200">
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      width="120"
                      align="center"
                      show-overflow-tooltip
                      label="客服">
                    </el-table-column>
                    <el-table-column
                      show-overflow-tooltip
                      label="处理状态"
                      align="center"
                      width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.state===1"><el-tag type="success"><i class="el-icon-success" style="margin-right: 5px" />已处理</el-tag></span>
                        <span v-if="scope.row.state===2"><el-tag><i class="el-icon-error" style="margin-right: 5px" />未处理</el-tag></span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="remark"
                      show-overflow-tooltip
                      align="center"
                      label="备注"
                      width="200">
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="card" style="margin-top: 28px;max-height: 524.2px">
                <div style="margin-bottom: 20px;float: right">
                  高出错需要及时改善排名图
                </div>
                <div id="remarkRankChart" style="height: 480px"></div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="编辑客诉整改完成率"
      :visible.sync="dialogVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row style="margin-bottom: 10px">
        <el-col>
          <div v-for="(data, index) in reasonData" :key="index">
            <el-form>
              <el-form-item :label="`${data.name}` + '(出错数：' + `${data.value}` + ')'">
                <el-input v-model="reasonInput[index]" size="small" placeholder="请输入整改完成率" onkeyup="value=value.replace(/[^\d.]/g,'')" @keyup.native="checkNumber(index)"><template slot="append">%(整改率)</template></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="float: right;margin-bottom: 20px">
            <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="reasonComLoading" @click="reasonCom">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>

import { getUser } from '@/utils/auth'
import * as echarts from 'echarts'
import HighCharts from 'highcharts'
import {
  getComplaintDeptRank,
  getComplaintNum,
  getComplaintReason,
  getComplaintRecord,
  getComplaintType
} from '@/api/work'

export default {
  name: 'shfw',
  data() {
    return {
      complaintRankTime: [],
      complaintNumTime: [],
      time: '',
      tableData: [],
      vo: {},
      dialogVisible: false,
      reasonData: [],
      reasonInput: [],
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      reasonComLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    const time = new Date()
    this.complaintRankTime[0] = (time.getFullYear() - 1) + '-' + (time.getMonth() === 11 ? 1 : (time.getMonth() + 2))
    this.complaintRankTime[1] = time.getFullYear() + '-' + (time.getMonth() + 1)
    this.time = time.getFullYear() + '-' + (time.getMonth() + 1)
    this.getComplaintDeptRank()
    this.getComplaintNum()
    this.getComplaintType()
    this.getComplaintRecord()
    this.getReasonData()
  },
  methods: {
    getComplaintDeptRank() {
      let startTime = ''
      let endTime = ''
      if (this.complaintRankTime !== null && this.complaintRankTime.length === 2) {
        startTime = this.complaintRankTime[0]
        endTime = this.complaintRankTime[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid
      }
      getComplaintDeptRank(data).then(response => {
        const complaintRankChart = echarts.init(document.getElementById('complaintRankChart'))
        const option = {
          grid: {
            top: '10%'
          },
          xAxis: {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: response.data.name
          },
          series: [{
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'right',
                  textStyle: {
                    color: '#800080'
                  }
                }
              }
            },
            data: response.data.num,
            type: 'bar'
          }]
        }
        option && complaintRankChart.setOption(option)
        window.addEventListener('resize', function() {
          complaintRankChart.resize()
        })
      }).catch(() => {
      })
    },
    getComplaintType() {
      const data = {
        time: this.time,
        userid: this.user.dUserid
      }
      getComplaintType(data).then(response => {
        this.vo = response.data.vo
        const complaintTypeChart = echarts.init(document.getElementById('complaintTypeChart'))
        const option = {
          grid: {
            top: '20%'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: response.data.record,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        option && complaintTypeChart.setOption(option)
        window.addEventListener('resize', function() {
          complaintTypeChart.resize()
        })
      }).catch(() => {
      })
    },
    getComplaintNum() {
      getComplaintNum({ userid: this.user.dUserid }).then(response => {
        const complaintRankChart = echarts.init(document.getElementById('complaintNumChart'))
        const option = {
          grid: {
            top: '10%',
            right: '17%'
          },
          yAxis: {
            type: 'category',
            data: response.data.name,
            position: 'right'
          },
          xAxis: {
            type: 'value',
            inverse: true
          },
          series: [{
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'left',
                  textStyle: {
                    color: '#800080'
                  }
                }
              }
            },
            data: response.data.num,
            type: 'bar'
          }]
        }
        option && complaintRankChart.setOption(option)
        window.addEventListener('resize', function() {
          complaintRankChart.resize()
        })
      }).catch(() => {
      })
    },
    getComplaintRecord() {
      const data = {
        limit: 10,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getComplaintRecord(data).then(response => {
        this.tableData = response.data
      })
    },
    getReasonData() {
      getComplaintReason({ userid: this.user.dUserid }).then(response => {
        this.reasonData = response.data
        const remarkRankChart = echarts.init(document.getElementById('remarkRankChart'))
        const option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            top: '20%'
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: response.data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              top: '30%',
              left: '10%'
            }
          ]
        }
        option && remarkRankChart.setOption(option)
        window.addEventListener('resize', function() {
          remarkRankChart.resize()
        })
        this.getCharts()
      }).catch(() => {
      })
    },
    getCharts() {
      this.option1 = HighCharts.chart('chart1', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        colors: ['#8085e9', '#2b908f'],
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}<b>{point.percentage}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '<b>{point.percentage}%</b>'
            }
          }
        },
        series: [{
          name: '',
          colorByPoint: true,
          data: [{
            name: this.reasonData[0].name,
            y: 100,
            sliced: true,
            selected: true
          }, {
            name: '未整改',
            y: 0
          }]
        }]
      })
      this.option2 = HighCharts.chart('chart2', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        colors: ['#90ed7d', '#2b908f'],
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}<b>{point.percentage}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '<b>{point.percentage}%</b>'
            }
          }
        },
        series: [{
          name: '',
          colorByPoint: true,
          data: [{
            name: this.reasonData[1].name,
            y: 100,
            sliced: true,
            selected: true
          }, {
            name: '未整改',
            y: 0
          }]
        }]
      })
      this.option3 = HighCharts.chart('chart3', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        colors: ['#e4d354', '#2b908f'],
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}<b>{point.percentage}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '<b>{point.percentage}%</b>'
            }
          }
        },
        series: [{
          name: '',
          colorByPoint: true,
          data: [{
            name: this.reasonData[2].name,
            y: 100,
            sliced: true,
            selected: true
          }, {
            name: '未整改',
            y: 0
          }]
        }]
      })
      this.option4 = HighCharts.chart('chart4', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        colors: ['#f45b5b', '#2b908f'],
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}<b>{point.percentage}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '<b>{point.percentage}%</b>'
            }
          }
        },
        series: [{
          name: '',
          colorByPoint: true,
          data: [{
            name: this.reasonData[3].name,
            y: 100,
            sliced: true,
            selected: true
          }, {
            name: '未整改',
            y: 0
          }]
        }]
      })
    },
    reasonCom() {
      if (!this.reasonComLoading) {
        this.reasonComLoading = true
        for (let i = 0; i < this.reasonInput.length; i++) {
          if (this.reasonInput[i] !== null) {
            const data = [{
              name: this.reasonData[i].name,
              y: Number(parseFloat(this.reasonInput[i]).toFixed(2)),
              sliced: true,
              selected: true
            }, {
              name: '未整改',
              y: Number((100 - (parseFloat(this.reasonInput[i]))).toFixed(2))
            }]
            if (i === 0) {
              this.option1.series[0].setData(data)
            } else if (i === 1) {
              this.option2.series[0].setData(data)
            } else if (i === 2) {
              this.option3.series[0].setData(data)
            } else if (i === 3) {
              this.option4.series[0].setData(data)
            }
          }
          this.dialogVisible = false
          this.reasonComLoading = false
        }
      }
    },
    checkNumber(index) {
      if (this.reasonInput[index] < 0 || this.reasonInput[index] > 100 || isNaN(Number(this.reasonInput[index]))) {
        this.reasonInput[index] = null
        this.$message.error('请输入正确的（0-100之间）整改完成率')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
